import {GetAPIHost} from "../utis/API";

export const GrayLogUrl = {
    getCurrent() {
        return (window.location.href.indexOf('localhost') !== -1) ? "/logging/v1/" : `${GetAPIHost()}/logging/v1/`;
    }
};
